import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';
import { setCommentAdded, useAppDispatch } from '@state';
import { NoteType } from '@rta/rta-blueprint-library';
import { useKeystoneSession } from '../../auth/use-keystone-session';

interface CommentFeatureParams extends FeatureHoookParams {
	commentText: string;
  }

export const useAddCommentFeature = (_params: CommentFeatureParams): Feature<string> => {
	const { commentText } = _params;
	const [controller] = useDesign();
	const dispatch = useAppDispatch();
	const { user } = useKeystoneSession();

	const kitchen = controller?.kitchen ?? null;

	const [disabled, tooltip] = (() => {
		if (!kitchen) return [true, 'Select a blueprint to add comments'];
		return [false, 'Add this comment'];
	})();

	return {
		name: 'add-comment',
		label: lang.comments.label.add,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled,
		value: commentText,
		hidden: false,
		handler: () => {
			if (kitchen && commentText.trim()) {
				kitchen.notes.add({
					message: commentText,
					artifactId: '',
					type: NoteType.NA,
					createdBy: user?.email || 'system'
				});

				dispatch(setCommentAdded([]));
			}
		}
	};
};
